module.exports = __webpack_public_path__ + "static/media/portland-state-university.98004f16.png";